import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Grid } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";

import constants from "../../assets/constants";
import * as PatientSessionActions from "../../state/redux/patientSession";
import { deepCopyObject } from "../../utils/helpers";
import AssessmentWizardDialog from "../dialogs/assessmentWizardDialog";
import UserDialog from "../dialogs/userDialog";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import PatientListItem from "../ui/patientListItem";
import Widget from "../ui/widget";
import WidgetContent from "../ui/widgetContent";
import WidgetList from "../ui/widgetList";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetTitle from "../ui/widgetTitle";

const PartnerPatients = props => {
  const { partnerPatients, proxyPatientODM, organizationODM } = props;

  const theme = useTheme();

  const [selectedPatient, setSelectedPatient] = useState(null);
  const [showAssessmentDialog, setShowAssessmentDialog] = useState(null);
  const [showSubjectAssessmentDialog, setShowSubjectAssessmentDialog] = useState(null);

  const [titleText, setTitleText] = useState(null);

  useEffect(() => {
    if (partnerPatients != null) {
      setTitleText(
        `${Object.entries(partnerPatients).length} Candidate${
          partnerPatients.length === 1 ? "" : "s"
        }`,
      );
    } else setTitleText("");
  }, [partnerPatients]);

  const getWidgetContent = () => {
    if (partnerPatients != null && partnerPatients.length > 0) {
      return (
        <WidgetList>
          {partnerPatients
            .sort((a, b) => a.omniData.familyName.localeCompare(b.omniData.familyName))
            .map((aPatientODM, index) => {
              return (
                <PatientListItem
                  key={`patientListItem-${aPatientODM._id}`}
                  patientODM={aPatientODM}
                  proxyPatientODM={proxyPatientODM}
                  onClickHandler={() => {
                    setSelectedPatient(aPatientODM);
                  }}
                  onAssessHandler={() => {
                    setShowSubjectAssessmentDialog(aPatientODM);
                  }}
                />
              );
            })}
        </WidgetList>
      );
    } else {
      return (
        <WidgetContent>
          <Grid
            container
            direction="row"
            justifyContent="center"
            alignContent="space-evenly"
            sx={{ height: "100%", color: theme.palette.commonground.contrastText }}
          >
            <Grid
              container
              item
              xs={12}
              justifyContent="center"
              sx={{ height: "56px", marginBottom: theme.spacing(1) }}
            >
              <Grid item xs={12} sx={{ textAlign: "center" }}>
                <Typography variant="overline" sx={{ lineHeight: 2, height: "56px" }}>
                  Looks like you haven't added any trial candidates yet
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </WidgetContent>
      );
    }
  };

  return (
    <Widget>
      <WidgetTitle title={"Applicants"} text={titleText} loading={partnerPatients == null}>
        <OmniResponsiveButton
          tooltipTitle="Add a new trial candidate"
          buttonText="Candidate"
          onClick={() => {
            setShowAssessmentDialog(
              organizationODM.omniData.defaultAsssesmentType
                ? organizationODM.omniData.defaultAsssesmentType
                : constants.assessmentIDs.omniHealthHistory,
            );
          }}
        />
      </WidgetTitle>

      {partnerPatients == null && <WidgetSkeleton />}
      {partnerPatients != null && getWidgetContent()}

      {selectedPatient && (
        <UserDialog
          open={selectedPatient != null}
          dialogTitle={`${selectedPatient._id == null ? "Add" : "Edit"} Candidate`}
          omniODM={deepCopyObject(selectedPatient)}
          onDelete={patient => {
            props.deletePatientRequest(patient._id);
            setSelectedPatient(null);
          }}
          onAccept={patient => {
            props.updatePatientRequest(patient);
            setSelectedPatient(null);
          }}
          onClose={() => {
            setSelectedPatient(null);
          }}
        />
      )}
      {showAssessmentDialog != null && (
        <AssessmentWizardDialog
          open={showAssessmentDialog != null}
          lockAssessmentOmniType={showAssessmentDialog}
          autoStartAssessment={true}
          onClose={() => {
            setShowAssessmentDialog(null);
          }}
        />
      )}
      {showSubjectAssessmentDialog != null && (
        <AssessmentWizardDialog
          open={showSubjectAssessmentDialog != null}
          lockSubjectODM={showSubjectAssessmentDialog}
          autoStartAssessment={true}
          onClose={() => {
            setShowSubjectAssessmentDialog(null);
          }}
        />
      )}
    </Widget>
  );
};
const mapStateToProps = state => ({
  partnerPatients: state.partnerSession.partnerPatients,
  proxyPatientODM: state.userSession.proxyPatientODM,
  organizationODM: state.userSession.organizationODM,
});

const mapDispatchToProps = {
  updatePatientRequest: PatientSessionActions.updatePatientRequest,
  deletePatientRequest: PatientSessionActions.deletePatientRequest,

  loadPatientODMRequest: PatientSessionActions.loadPatientODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PartnerPatients));
